import { loadQualifiedDocsChat } from '@lib/qualified';
import { disableAnalytics } from '@config';

export const lazyLoadedScripts = () => {
  if (!disableAnalytics) {
    loadQualifiedDocsChat();
  }
};

export const loadSessionFromUrl = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const accessToken = urlParams.get('at');
  const workspaceId = urlParams.get('w');
  const email = urlParams.get('e');
  const adminEmail = urlParams.get('ae');

  if (accessToken && workspaceId && email && adminEmail) {
    loadSession({ accessToken, workspaceId, email, adminEmail });
  }
};

const loadSession = ({ accessToken, workspaceId, email, adminEmail }) => {
  localStorage.setItem(
    'userStore',
    JSON.stringify({
      token: accessToken,
      loggedIn: true,
      selectedWorkspaceId: workspaceId,
      email,
    }),
  );
  localStorage.setItem('lastVisitedWorkspace', workspaceId);
  localStorage.setItem('adminEmail', adminEmail);
  window.location.href = window.location.origin + window.location.pathname;
};
